import { tv } from 'tailwind-variants';

const typographyClasses = tv({
  base: '',
  variants: {
    size: {
      h1: 'text-h1',
      h2: 'text-h2',
      h3: 'text-h3',
      h4: 'text-h4',
      h5: 'text-h5',
      h6: 'text-h6',
      default: 'text-md',
      small: 'text-sm',
      mini: 'text-xs',
    },
    type: {
      title: 'font-bold font-poppins text-mono-color-black',
      titleSection: 'font-bold font-notoSans uppercase text-mono-color-dark',
      lead: 'text-lg font-notoSans text-mono-color-darkest',
      p: 'font-notoSans text-mono-color-darkest',
      display: 'font-bold font-poppins text-5xl leading-[4.5rem]',
    },
    variant: {
      normal: 'font-light',
      italic: 'italic font-normal',
    },
    weight: {
      normal: 'font-normal',
      bold: 'font-bold',
    },
  },
  compoundVariants: [
    {
      type: ['title', 'titleSection'],
      weight: 'normal',
      className: 'font-bold',
    },
    {
      type: 'lead',
      weight: 'normal',
      variant: 'normal',
      className: 'font-light',
    },
    {
      type: 'lead',
      weight: 'bold',
      className: 'font-semibold',
    },
  ],
});

export { typographyClasses };
